import { MonitoringCompany } from "@safetyculture/s12-apis-connect-web/s12/loneworker/v1/monitoring_pb";

import { updateLoneworkerOrgSettings } from "../../../../api/endpoints/lone-worker";
import { callOptionsHeaders } from "../../../../api/helpers";
import { GrpcError } from "../../../../context/snackbar-context";
import { SettingsContextType } from "./settings-context";

export const save = (
  settingsContext: SettingsContextType,
  showError: (e: GrpcError) => void
) => {
  const {
    setIsOpenConfirmDialog,
    setIsSaving,
    monitoringSeatsTotal,
    setIsSnackbarOpen,
    setMonitoringSeatsUsed,
    setMonitoringSeatsTotal,
    roleId,
    monitoringCompany,
    regionCode,
  } = settingsContext;

  setIsOpenConfirmDialog(false);
  setIsSaving(true);

  updateLoneworkerOrgSettings(
    roleId,
    monitoringSeatsTotal || 0,
    monitoringCompany,
    callOptionsHeaders(regionCode, roleId)
  )
    .then(() => {
      setIsSnackbarOpen(true);
      if (monitoringCompany === MonitoringCompany.UNSPECIFIED) {
        setMonitoringSeatsUsed(0);
        setMonitoringSeatsTotal(0);
      }
    })
    .catch(showError)
    .finally(() => {
      setIsSaving(false);
    });
};
